import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import ReactSelect from "react-select";
import FormError from "./FormError";

const SelectMultiple = ({ value, onChange, loading, label, alert, placeholder, name, required, className, icon, array, image, isMulti, nameArray, tooltip, disabled }) => {
    const [options, setOptions] = useState([]);
    const [defaultValue, setDefaultValue] = useState(isMulti ? [] : null);

    const customStyles = {
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
        menu: (provided) => ({
            ...provided,
            maxHeight: '150px',
            overflowY: 'auto',
            margin: 0,
        }),
        menuList: (provided) => ({
            ...provided,
            padding: 0,
            maxHeight: '150px',
            overflowY: 'auto',
        }),
    };

    useEffect(() => {
        // Limpiar selecciones si el valor es vacío
        if (value === '' || (Array.isArray(value) && value.length === 0)) {
            setDefaultValue(isMulti ? [] : null);
            return;
        }

        if (isMulti) {
            if (Array.isArray(value) && value.length > 0) {
                const arraySet = value.map((id) => {
                    const foundItem = array.find((item) => item.id == id);
                    return foundItem ? {
                        value: foundItem.id,
                        label: nameArray ? foundItem[nameArray] : foundItem.name,
                        ...(image && { image: foundItem[image] })
                    } : null;
                }).filter(Boolean);
                setDefaultValue(arraySet);
            }
        } else {
            const foundItem = array.find((item) => item.id == value);
            if (foundItem) {
                setDefaultValue({
                    value: foundItem.id,
                    label: nameArray ? foundItem[nameArray] : foundItem.name,
                    ...(image && { image: foundItem[image] })
                });
            } else {
                setDefaultValue(null);
            }
        }
    }, [value, array, nameArray, image, isMulti]);

    useEffect(() => {
        if (Array.isArray(array) && array.length > 0) {
            const arraySet = array.map((item) => ({
                value: item.id,
                label: nameArray ? item[nameArray] : item.name,
                ...(image && { image: item[image] })
            }));
            setOptions(arraySet);
        } else {
            setOptions([]);
        }
    }, [array, nameArray, image]);

    const formatOptionLabel = ({ label, image }) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {image && <img className={`w-8 h-8 mr-2 ${image === '' && 'invisible'}`} src={`data:image/png;base64,${image}`} alt="" />}
            {label}
        </div>
    );

    const handleChange = (selectedOption) => {
        if (isMulti) {
            setDefaultValue(selectedOption || []);
            onChange(selectedOption ? selectedOption.map((item) => item.value) : []);
        } else {
            setDefaultValue(selectedOption || null);
            onChange(selectedOption ? selectedOption.value : null);
        }
    };

    return (
        <>
            {label && <label className="mb-2 text-white">
                <span>{label} {required && <span className="text-red-500">*</span>}</span>
            </label>}

            {loading ? (
                <Skeleton className="w-full rounded py-3 px-5 text-2xl" />
            ) : (
                <div className="relative">
                    <ReactSelect
                        name={name}
                        onChange={handleChange}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                backgroundColor: '#3e5a6c',
                                borderColor: '#d1d5db', // gray-300
                                // padding: '0.5rem 1rem', // px-4 py-2
                                fontSize: '1.25rem', // text-xl
                                color: '#ffffff',
                                borderRadius: '0.375rem', // rounded
                                transition: 'all 0.2s ease-in-out',
                                backgroundClip: 'padding-box',
                                boxShadow: state.isFocused ? '0 0 0 0.15rem rgba(255,255,255,0.25)' : 'none',
                                '&:hover': {
                                    borderColor: '#ffffff',
                                },
                            }),
                            menu: (base) => ({
                                ...base,
                                backgroundColor: '#222222', // fondo del dropdown
                                color: '#ffffff',
                                zIndex: 9999,
                            }),
                            menuList: (base) => ({
                                ...base,
                                backgroundColor: '#222222',
                                maxHeight: '150px',
                            }),
                            option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isFocused
                                    ? '#241145' // Light-purple
                                    : 'transparent',
                                color: '#ffffff',
                                cursor: 'pointer',
                                '&:active': {
                                    backgroundColor: '#824599', // purple-button
                                },
                            }),
                            input: (base) => ({
                                ...base,
                                color: '#ffffff',
                            }),
                            placeholder: (base) => ({
                                ...base,
                                color: '#81939E', // holder-gray
                            }),
                            singleValue: (base) => ({
                                ...base,
                                color: '#ffffff',
                            }),
                            multiValue: (base) => ({
                                ...base,
                                backgroundColor: '#fff', // input-blue
                                color: '#ffffff',
                            }),
                            multiValueLabel: (base) => ({
                                ...base,
                                color: '#000',
                            }),
                            multiValueRemove: (base) => ({
                                ...base,
                                color: '#ffffff',
                                ':hover': {
                                    backgroundColor: '#C87100', // dark-yellow
                                    color: 'white',
                                },
                            }),
                        }}
                        value={defaultValue}
                        isMulti={isMulti}
                        options={options}
                        isClearable={true}
                        formatOptionLabel={image ? formatOptionLabel : null}
                        hideSelectedOptions={true}
                        placeholder={placeholder || "Seleccione una opción"}
                        noOptionsMessage={() => 'No hay más opciones'}
                        menuPortalTarget={document.body}
                        menuPlacement="auto"
                        isDisabled={disabled || false}
                    />
                    {icon && <span className="absolute left-4 top-1/2 transform -translate-y-1/2">{icon}</span>}
                </div>
            )}

            {alert && <FormError errors={alert} name={name} />}
        </>
    );
};

SelectMultiple.defaultProps = {
    array: [],
    value: null,
    nameArray: 'name',
    image: null,
    isMulti: false,
};

export default SelectMultiple;